import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PlannerEndpoints } from '../constants/planner-endpoints.const';

@Injectable({
    providedIn: 'root'
})
export class GeoService {

    constructor(private http: HttpClient) { }

    public async getContinents(): Promise<any> {
        return await this.http.get(PlannerEndpoints.continents, {})
            .toPromise()
            .then((res: any) => {
                return Promise.resolve(res);
            })
            .catch(err => {
                return Promise.resolve([]);
            });
    }

    public getChildren(url: string): Promise<any> {
        const address = PlannerEndpoints.geoBase + url;
        return this.http.get(address, {})
            .toPromise()
            .then((res: any) => {
                return Promise.resolve(res);
            })
            .catch(err => {
                return Promise.resolve([]);
            });
    }
}
